import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { AuthService } from "../auth.service";
import { SharedService } from "src/app/services/shared.service";
import { AlertService } from "src/app/services/alert.service";
import { validateVerticalPosition } from "@angular/cdk/overlay";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
})
export class LoginComponent implements OnInit {
  showForgotPassword: boolean = false;
  showVerifyOTP: boolean = false;
  otpVerified: boolean = false;
  passwordChanged: boolean = false;
  isConfirmPasswordValid: boolean = false;
  forgotPassRecoverOPT: number;
  // confirmPassword: string;
  password: string = "password";
  confPassword: string = "password";
  baseUrlImage = environment.baseUrlImage;
  show = false;
  confPassShow = false;
  forgotPasswordOPT = [{ key: 1, value: "Email" }];
  logInForm = new FormGroup({
    email: new FormControl("", [Validators.email, Validators.required]),
    password: new FormControl("", [Validators.required]),
  });
  forgotPassForm = new FormGroup({
    email: new FormControl("", [Validators.required, Validators.email]),

    otp: new FormControl(""),
    password: new FormControl("", [
      Validators.required,
      Validators.pattern(
        "(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-zd$@$!%*?&].{7,}"
      ),
    ]),
    confirmPassword: new FormControl("", [Validators.required]),
  });
  constructor(
    private router: Router,
    private authService: AuthService,
    private sharedService: SharedService,
    private alertService: AlertService
  ) {}

  ngOnInit() {
    console.log(
      "// this.passwordChanged = true;",
      this.passwordChanged,
      !this.passwordChanged
    );
  }

  noWhitespaceValidator(control: FormControl) {
    const isSpace = (control.value || "").match(/\s/g);
    return isSpace ? { whitespace: true } : null;
  }

  onLogIn() {
    let postLogInData = {
      email: this.logInForm.controls["email"].value,
      password: this.logInForm.controls["password"].value,
    };
    console.log("postLogInData", postLogInData);
    this.sharedService.showLoader();
    this.authService.logIn(postLogInData).subscribe((res: any) => {
      console.log("onLogIn", res);
      if (res.metadata.code == "200") {
        sessionStorage.setItem("userNameId", res.result.userNameId);
        sessionStorage.setItem("siteDetails", JSON.stringify(res.result.site));
        sessionStorage.setItem("userId", res.result.userId);
        sessionStorage.setItem("role", JSON.stringify(res.result.role));
        this.router.navigateByUrl("dashboard");
        let siteData = JSON.parse(sessionStorage.getItem("siteDetails"));

        let userId = sessionStorage.getItem("userId");

        console.log("siteData[0].id", siteData[0].id);
        console.log("userId", userId);

        this.authService
          .getDataAsPerSiteId(siteData[0].id, userId)
          .subscribe((res: any) => {
            console.log("onChangeSiteId", res);
            this.sharedService.hideLoader();

            if (res.metadata.code === "200") {
              console.log("token=====>", res.result.accessToken);
              this.authService.setToken(res.result.accessToken);

              this.authService.setRefreshToken(res.result.refreshToken);

              sessionStorage.setItem("siteId", res.result.sites.id);

              sessionStorage.setItem("orgId", res.result.sites.compId.orgId.id);
              sessionStorage.setItem("CompId", res.result.sites.compId.id);

              // location.reload();
              this.router.navigateByUrl("dashboard");
            }
          });
      } else {
        this.sharedService.hideLoader();

        this.alertService.alert(res.metadata.message, "info");
      }
    });
  }
  onForgotPass() {
    this.showForgotPassword = true;
  }
  onClickChip(value: number) {
    this.forgotPassRecoverOPT = value;
    if (this.forgotPassRecoverOPT == 1) {
      this.forgotPassForm.controls["email"].setValidators([
        Validators.required,
        Validators.email,
        this.noWhitespaceValidator,
      ]);
      this.forgotPassForm.controls["mobileNo"].setValidators(null);
    } else {
      this.forgotPassForm.controls["mobileNo"].setValidators([
        Validators.required,
      ]);
      this.forgotPassForm.controls["email"].setValidators(null);
    }
  }
  onSendOtp() {
    if (
      this.forgotPassForm.controls["email"].value == "" ||
      this.noWhitespaceValidator(this.forgotPassForm.controls["email"]) != null
    ) {
      this.alertService.alert(
        "Please enter a email or email does not contain any space",
        "info"
      );
    } else {
      let postSendOtpData: any;

      postSendOtpData = {
        email: this.forgotPassForm.controls["email"].value,
      };

      this.sharedService.showLoader();
      this.authService.sendOTP(postSendOtpData).subscribe((res: any) => {
        this.sharedService.hideLoader();
        if (res.metadata.code == 200) {
          this.alertService.alert(res.metadata.message, "success");
          this.showVerifyOTP = true;
          this.timer(60);
        } else {
          this.alertService.alert(res.metadata.message, "info");
        }
      });
    }
  }

  onClickVerify() {
    if (
      this.forgotPassForm.controls["otp"].value == "" ||
      this.noWhitespaceValidator(this.forgotPassForm.controls["otp"]) != null
    ) {
      this.alertService.alert(
        "Please enter a recived OTP or OTP does not contain any space",
        "info"
      );
    } else {
      let postVerifyData: any;

      postVerifyData = {
        email: this.forgotPassForm.controls["email"].value,
        otp: this.forgotPassForm.controls["otp"].value,
      };

      this.sharedService.showLoader();
      this.authService.verifyOTP(postVerifyData).subscribe((res: any) => {
        console.log("onClickVerify", res);
        this.sharedService.hideLoader();
        if (res.metadata.code == 200) {
          this.alertService.alert(res.metadata.message, "success");
          this.otpVerified = true;
        } else {
          this.alertService.alert(res.metadata.message, "info");
        }
      });
    }
  }
  onBack() {
    this.showForgotPassword = false;
  }

  onChangePassword() {
    if (
      this.forgotPassForm.controls["password"].value == "" ||
      this.noWhitespaceValidator(this.forgotPassForm.controls["password"]) !=
        null
    ) {
      this.alertService.alert(
        "Please enter a password or password does not contain any space",
        "info"
      );
    } else if (
      this.forgotPassForm.controls["confirmPassword"].value == "" ||
      this.noWhitespaceValidator(
        this.forgotPassForm.controls["confirmPassword"]
      ) != null
    ) {
      this.alertService.alert(
        "Please enter a confirm password or confirm password does not contain any space",
        "info"
      );
    } else {
      let postChangePasswordData: any;
      postChangePasswordData = {
        email: this.forgotPassForm.controls["email"].value,
        password: this.forgotPassForm.controls["confirmPassword"].value,
      };
      this.sharedService.showLoader();
      this.authService
        .changePassword(postChangePasswordData)
        .subscribe((res: any) => {
          console.log("changePassword", res);
          this.sharedService.hideLoader();
          if (res.metadata.code == 204) {
            this.alertService.alertReload(
              res.metadata.message,
              "success",
              "login"
            );
            // this.passwordChanged = true;
            // this.showForgotPassword = false;
          } else {
            this.alertService.alert(res.metadata.message, "info");
            this.showForgotPassword = false;
          }
        });
    }
  }

  display: any;

  timer(minute) {
    // let minute = 1;
    let seconds: number = minute * 60;
    let textSec: any = "0";
    let statSec: number = 60;

    const prefix = minute < 10 ? "0" : "";

    const timer = setInterval(() => {
      seconds--;
      if (statSec != 0) statSec--;
      else statSec = 59;

      if (statSec < 10) {
        textSec = "0" + statSec;
      } else textSec = statSec;

      this.display = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;

      // if (seconds == 0) {
      //   console.log("finished");
      //   clearInterval(timer);
      // }
      if (this.otpVerified == true) {
        clearInterval(timer);
      }
    }, 1000);
  }

  onCHangePassword(CPvalue: any) {
    console.log("Pvalue", this.forgotPassForm.controls["password"].value);

    console.log("CPvalue", CPvalue);

    if (this.forgotPassForm.controls["password"].value === CPvalue) {
      console.log("password is matching");
      this.isConfirmPasswordValid = false;
      console.log("this.isConfirmPasswordValid", this.isConfirmPasswordValid);
    } else {
      console.log("password is not matching");
      this.isConfirmPasswordValid = true;
      console.log("this.isConfirmPasswordValid", this.isConfirmPasswordValid);
    }
  }

  onClick() {
    if (this.password === "password") {
      this.password = "text";
      this.show = true;
    } else {
      this.password = "password";
      this.show = false;
    }
  }
  onCinfirmPassHideShow() {
    if (this.confPassword === "password") {
      this.confPassword = "text";
      this.confPassShow = true;
    } else {
      this.confPassword = "password";
      this.confPassShow = false;
    }
  }
}
